import React, { useState } from 'react';
import CrewSelect from 'components/CrewSelect';
import styled from 'styled-components';
import StyledNavLink from 'components/nav/Link';
import StyledNavTabs from 'components/nav/Tabs';

import {
  TabContent,
  TabPane,
  NavItem,
  Label,
  Form,
  FormGroup,
} from 'reactstrap';

import { Button } from '@shoflo/polymer/components/Button/Button';
const StyledLabel = styled(Label)`
  font-size: 14px;
  line-height: 16px;
  font-weight: 600;
  color: #333;
`;

const InviteForm = ({ crewAutoCompleteOptions, onSubmit, onCancel }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  return (
    <>
      <StyledNavTabs tabs>
        <NavItem>
          <StyledNavLink active={true}>Invite via email</StyledNavLink>
        </NavItem>
      </StyledNavTabs>

      <TabContent activeTab={1}>
        <TabPane tabId={1}>
          The following people will be invited as team admins:
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              onSubmit(selectedOptions);
            }}
          >
            <FormGroup>
              <StyledLabel>Email</StyledLabel>
              <CrewSelect
                selectedOptions={selectedOptions}
                options={crewAutoCompleteOptions}
                onChange={setSelectedOptions}
              />
            </FormGroup>

            <div className="float-end">
              <Button data-testid="createButton" color="primary">
                Send
              </Button>{' '}
              {onCancel && (
                <Button
                  data-testid="cancelButton"
                  type="button"
                  onClick={onCancel}
                  color="secondary"
                  variant="outlined"
                >
                  Cancel
                </Button>
              )}
            </div>
          </Form>
        </TabPane>
      </TabContent>
    </>
  );
};

InviteForm.defaultProps = {
  crewAutoCompleteOptions: [],
};

export default InviteForm;
